module.exports = __webpack_public_path__ + "static/media/clinical_case_icon.634f18d9.svg";